'use client'

import { useRouter } from 'next/navigation'
import { ArrowLeftIcon } from '@radix-ui/react-icons'
import { Button, ButtonProps } from '../../ui/button'
import { cn } from '@utils'

export type BackButtonProps = ButtonProps & {
  to?: string | number
  label?: string
}

export function BackButton({
  to = -1,
  className,
  onClick,
  label = 'Back',
  ...props
}: BackButtonProps) {
  const router = useRouter()
  const handleOnClick =
    onClick ||
    (() => {
      if (typeof to === 'number') {
        if (to === -1) {
          router.back()
        } else if (to === 1) {
          router.forward()
        }
      } else {
        router.push(to)
      }
    })

  return (
    <Button
      className={cn('px-0', className)}
      variant="quaternary"
      onClick={handleOnClick}
      {...props}
    >
      <div className="flex items-center gap-2">
        <ArrowLeftIcon className="h-5 w-5" />
        {label}
      </div>
    </Button>
  )
}

export function BackButtonMobile({
  to = -1,
  className,
  label = 'Back',
  ...props
}: BackButtonProps) {
  const router = useRouter()

  const handleClick = () => {
    if (typeof to === 'number') {
      if (to === -1) {
        router.back()
      } else if (to === 1) {
        router.forward()
      }
    } else {
      router.push(to)
    }
  }

  return (
    <Button
      variant={'tertiary'}
      className={cn('sm:hidden text-cw-midnight-purple', className)}
      onClick={handleClick}
      aria-label={label}
      {...props}
    >
      <ArrowLeftIcon className="h-5 w-5 text-cw-midnight-purple" />
    </Button>
  )
}
